import { ChangeDetectorRef, Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent, AlertModule, ButtonCloseDirective, ProgressBarComponent, ProgressBarDirective, ProgressComponent, ToastBodyComponent, ToastCloseDirective, ToastComponent, ToasterService, ToastHeaderComponent } from '@coreui/angular-pro';

@Component({
  selector: 'ow-toast-alert',
  standalone: true,
  imports: [
    CommonModule,
    ToastComponent, ToastHeaderComponent, ToastBodyComponent, ToastCloseDirective,
    ButtonCloseDirective
  ],
  templateUrl: './ow-toast-alert.component.html',
  styleUrls: ['./ow-toast-alert.component.scss'],
  providers: [{ provide: ToastComponent, useExisting: forwardRef(() => ToastAlertComponent) }]
})
export class ToastAlertComponent extends ToastComponent {

  @Input() closeButton = true;
  @Input() message = '';

  constructor(
    public override hostElement: ElementRef,
    public override renderer: Renderer2,
    public override toasterService: ToasterService,
    public override changeDetectorRef: ChangeDetectorRef
  ) {
    super(hostElement, renderer, toasterService, changeDetectorRef);
  }

  get textColorClass(): string {
    const toastColor = this.color();
    switch (toastColor) {
      case 'warning':
        return 'text-dark'; // Dark text for yellow background
      case 'success':
      case 'danger':
      case 'info':
      default:
        return 'text-white'; // White text for other backgrounds
    }
  }
}